<file-thumbnails-list [idPrefix]="(idPrefix + smpFileCategory + '.thumbnail_list.')"
                      [fileMetaList]="fileMetaList"
                      [withIconAvatars]="true"
                      [dynamicDeleteBtnFn]="dynamicDeleteBtnFn"
                      [disabledOptions]="disabledOptions"
                      [labelProp]="labelProp"
                      (view)="viewFile($event)"
                      (download)="downloadFile($event)"
                      (delete)="deleteFile($event)"
                      (edit)="editFile($event)">
</file-thumbnails-list>
